/* eslint-disable max-len, arrow-parens */

import * as types from '../constants/ActionTypes';

function action(type, payload = {}) {
  return { type, ...payload };
}

export const chargers = {
  request: (args) => action(types.CHARGERS.REQUEST, { args }),
  success: (args, response) => action(types.CHARGERS.SUCCESS, { args, response }),
  failure: (args, error) => action(types.CHARGERS.FAILURE, { args, error }),
};

export const chargersNearUser = {
  request: (args) => action(types.CHARGERS_NEAR_USER.REQUEST, { args }),
  success: (args, response) => action(types.CHARGERS_NEAR_USER.SUCCESS, { args, response }),
  failure: (args, error) => action(types.CHARGERS_NEAR_USER.FAILURE, { args, error }),
};

export const chargersNearUserNext = {
  request: (endpoint) => action(types.CHARGERS_NEAR_USER_NEXT.REQUEST, { endpoint }),
  success: (endpoint, response) => action(types.CHARGERS_NEAR_USER_NEXT.SUCCESS, { endpoint, response }),
  failure: (endpoint, error) => action(types.CHARGERS_NEAR_USER_NEXT.FAILURE, { endpoint, error }),
};

export const places = {
  request: (args) => action(types.PLACES.REQUEST, { args }),
  success: (args, response) => action(types.PLACES.SUCCESS, { args, response }),
  failure: (args, error) => action(types.PLACES.FAILURE, { args, error }),
};

export const cachedChargers = {
  request: (url) => action(types.CACHED_CHARGERS.REQUEST, { url }),
  success: (url, response) => action(types.CACHED_CHARGERS.SUCCESS, { url, response }),
  failure: (url, error) => action(types.CACHED_CHARGERS.FAILURE, { url, error }),
};

export const chargersNearIp = {
  request: () => action(types.CHARGERS_NEAR_IP.REQUEST, {}),
  success: (response) => action(types.CHARGERS_NEAR_IP.SUCCESS, { response }),
  failure: (error) => action(types.CHARGERS_NEAR_IP.FAILURE, { error }),
};

export const chargersRanked = {
  request: () => action(types.CHARGERS_RANKED.REQUEST, {}),
  success: (response) => action(types.CHARGERS_RANKED.SUCCESS, { response }),
  failure: (error) => action(types.CHARGERS_RANKED.FAILURE, { error }),
};

export const chargerReviews = {
  request: (charger) => action(types.CHARGER_REVIEWS.REQUEST, { charger }),
  success: (charger, response) => action(types.CHARGER_REVIEWS.SUCCESS, { charger, response }),
  failure: (charger, error) => action(types.CHARGER_REVIEWS.FAILURE, { charger, error }),
};

export const chargerImages = {
  request: (charger) => action(types.CHARGER_IMAGES.REQUEST, { charger }),
  success: (charger, response) => action(types.CHARGER_IMAGES.SUCCESS, { charger, response }),
  failure: (charger, error) => action(types.CHARGER_IMAGES.FAILURE, { charger, error }),
};

export const newChargerReview = (charger, review) => action(types.NEW_CHARGER_REVIEW, { charger, review });
export const newChargerImage = (charger, image) => action(types.NEW_CHARGER_IMAGE, { charger, image });

export const placeReviews = {
  request: (place) => action(types.PLACE_REVIEWS.REQUEST, { place }),
  success: (place, response) => action(types.PLACE_REVIEWS.SUCCESS, { place, response }),
  failure: (place, error) => action(types.PLACE_REVIEWS.FAILURE, { place, error }),
};

export const chargerPlaces = {
  request: (charger, args) => action(types.CHARGER_PLACES.REQUEST, { charger, args }),
  success: (charger, args, response) => action(types.CHARGER_PLACES.SUCCESS, { charger, args, response }),
  failure: (charger, args, error) => action(types.CHARGER_PLACES.FAILURE, { charger, args, error }),
};

export const fetchChargers = (args) => action(types.FETCH_CHARGERS, { args });
export const fetchChargersNearIp = () => action(types.FETCH_CHARGERS_NEAR_IP, {});

export const filterChargers = (filter) => action(types.SET_CHARGER_FILTER, { filter });
export const changeMap = (center, zoom) => action(types.CHANGE_MAP, { center, zoom });
export const chargerMapClick = (charger) => action(types.CHARGER_MAP_CLICK, { charger });
export const setCurrentCharger = (charger) => action(types.SET_CURRENT_CHARGER, { charger });
export const setChargerShowPlaceCategories = (categories) => action(types.SET_CHARGER_SHOW_PLACE_CATEGORIES, { categories });

export const newPlace = (data) => action(types.NEW_PLACE, { data });
export const newPlaceReview = (place, review) => action(types.NEW_PLACE_REVIEW, { place, review });
export const newPlaceUpdate = (place, update) => action(types.NEW_PLACE_UPDATE, { place, update });

export const currentUser = {
  request: () => action(types.CURRENT_USER.REQUEST, {}),
  success: (response) => action(types.CURRENT_USER.SUCCESS, { response }),
  failure: (error) => action(types.CURRENT_USER.FAILURE, { error }),
};

const userAction = {
  request: (username) => action(types.USER.REQUEST, { username }),
  success: (username, response) => action(types.USER.SUCCESS, { username, response }),
  failure: (username, error) => action(types.USER.FAILURE, { username, error }),
};
export { userAction as user };

export const users = {
  request: (args) => action(types.USERS.REQUEST, { args }),
  success: (args, response) => action(types.USERS.SUCCESS, { args, response }),
  failure: (args, error) => action(types.USERS.FAILURE, { args, error }),
};

export const countries = {
  request: () => action(types.COUNTRIES.REQUEST, {}),
  success: (response) => action(types.COUNTRIES.SUCCESS, { response }),
  failure: (error) => action(types.COUNTRIES.FAILURE, { error }),
};

export const states = {
  request: () => action(types.STATES.REQUEST, {}),
  success: (response) => action(types.STATES.SUCCESS, { response }),
  failure: (error) => action(types.STATES.FAILURE, { error }),
};

export const page = (data) => action(types.PAGE, { data });

export const updateUser = (user) => action(types.UPDATE_USER, { user });

export const geolocation = {
  request: () => action(types.GEOLOCATION.REQUEST, {}),
  success: (position) => action(types.GEOLOCATION.SUCCESS, { position }),
  failure: (error) => action(types.GEOLOCATION.FAILURE, { error }),
};

export const setCenterOnCurrentLocation = (value) => action(types.SET_CENTER_ON_CURRENT_LOCATION, { value });

export const login = {
  request: (username, password) => action(types.LOGIN.REQUEST, { username, password }),
  success: (username, password, response) => action(types.LOGIN.SUCCESS, { username, password, response }),
  failure: (username, password, error) => action(types.LOGIN.FAILURE, { username, password, error }),
};

export const logout = {
  request: () => action(types.LOGOUT.REQUEST, {}),
  success: (response) => action(types.LOGOUT.SUCCESS, { response }),
  failure: (error) => action(types.LOGOUT.FAILURE, { error }),
};



// WEBPACK FOOTER //
// ./app/scripts/actions/index.js